import { Box, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import styles from '../styles'

const GraphTittle: FC = ({ tittle }: any) => {
  return (
    <Box {...styles.graphView.tittleContainer}>
      <Box {...styles.graphView.circle} />
      <Spacer direction="horizontal" size={20} />
      <Text {...styles.graphView.tittle}>{tittle}</Text>
    </Box>
  )
}

export { GraphTittle }
